import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import App from './App';

const LoginPage = lazy(() => import('./pages/auth/LoginPage').then(m => ({ default: m.LoginPage })));
const ProfilePage = lazy(() => import('./pages/auth/ProfilePage').then(m => ({ default: m.ProfilePage })));
const PasswordChangePage = lazy(() => import('./pages/auth/PasswordChangePage').then(m => ({ default: m.PasswordChangePage })));
const WidgetPage = lazy(() => import('./pages/WidgetPage'));

const LoadingSpinner = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
      <p className="mt-4 text-gray-600">Loading...</p>
    </div>
  </div>
);

function AppWithAuth() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <AuthProvider>
          <Suspense fallback={<LoadingSpinner />}>
            <Routes>
              {/* Public routes */}
              <Route path="/login" element={<LoginPage />} />
              {/* HIS Widget — no ProtectedRoute; token arrives via URL param */}
              <Route path="/widget" element={<WidgetPage />} />

              {/* Protected routes */}
              <Route path="/" element={<ProtectedRoute><App /></ProtectedRoute>} />
              <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
              <Route path="/profile/change-password" element={<ProtectedRoute><PasswordChangePage /></ProtectedRoute>} />

              {/* Catch all */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Suspense>
        </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default AppWithAuth;
